import { useEffect, useState } from 'react'
import type { MarketPoint } from './types'

/**
 * SmartPulse verisi — PTF, SMF ve sistem yönü, kontrat anahtarına göre.
 *
 * EPİAŞ tahtası saniyede bir akarken bu veri saatlik ve çok daha yavaş
 * değişiyor; WebSocket akışına karıştırmak yerine kendi periyoduyla yoklanıyor.
 * Sunucu da aynı aralıkta arka planda tazeliyor, yani istek anında ağa
 * çıkılmıyor.
 */

const INTERVAL_MS = 60_000

export function useMarketData(): Record<string, MarketPoint> {
  const [points, setPoints] = useState<Record<string, MarketPoint>>({})

  useEffect(() => {
    const aborter = new AbortController()

    const fetchOnce = () => {
      fetch('/api/market-data', { signal: aborter.signal })
        .then((response) => (response.ok ? response.json() : null))
        // Hata durumunda son bilinen veri korunuyor: boş nesneyle üzerine
        // yazmak sütunu sebepsiz boşaltırdı.
        .then((data: Record<string, MarketPoint> | null) => data && setPoints(data))
        .catch((err) => {
          if (err.name !== 'AbortError') console.error('SmartPulse verisi alınamadı', err)
        })
    }

    fetchOnce()
    const timer = window.setInterval(fetchOnce, INTERVAL_MS)
    return () => {
      aborter.abort()
      window.clearInterval(timer)
    }
  }, [])

  return points
}
